import React, { useEffect, useRef } from 'react';
import { ImageGeneratingTile } from './ImageGeneratingTile';
import { ImageCard } from './ImageCard';
import { itemsFromAssistantMessage } from '../../api/images.api';

const promptForAssistant = (messages, assistant) => {
  const index = messages.findIndex((item) => item.id === assistant.id);
  for (let i = index - 1; i >= 0; i -= 1) {
    if (messages[i].role === 'user') {
      return messages[i].content || messages[i].message || '';
    }
  }
  return '';
};

export const ImageThread = ({
  messages = [],
  sending = false,
  sendingPrompt = '',
  onView,
  onDownload,
  onDelete,
  onCopyLink
}) => {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: 'end' });
  }, [messages, sending]);

  return (
    <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-2 pb-4">
      {messages.map((message) => {
        if (message.role === 'user') {
          return (
            <div key={message.id} className="ms-auto max-w-[85%] space-y-2 rounded-2xl bg-neutral-900 px-4 py-3 text-sm text-white dark:bg-white dark:text-neutral-950">
              {(message.imageUrls || []).length > 0 ? (
                <div className="grid gap-2 sm:grid-cols-2">
                  {message.imageUrls.map((url) => (
                    <img key={url} src={url} alt="" className="w-full rounded-xl object-cover" />
                  ))}
                </div>
              ) : null}
              <div className="whitespace-pre-wrap">{message.content || message.message}</div>
            </div>
          );
        }

        const items = itemsFromAssistantMessage(message, promptForAssistant(messages, message));
        return (
          <div key={message.id} className="max-w-[90%] space-y-2">
            {message.content || message.message ? (
              <div className="text-sm text-neutral-500">{message.content || message.message}</div>
            ) : null}
            <div className="grid gap-3 sm:grid-cols-2">
              {items.map((item) => (
                <ImageCard
                  key={`${item.messageId}-${item.url}`}
                  item={item}
                  onView={onView}
                  onDownload={onDownload}
                  onDelete={onDelete}
                  onCopyLink={onCopyLink}
                />
              ))}
            </div>
          </div>
        );
      })}
      {sending ? (
        <div className="max-w-xs">
          <ImageGeneratingTile prompt={sendingPrompt} />
        </div>
      ) : null}
      <div ref={endRef} />
    </div>
  );
};
